export const EXPORT_EXTENSION = 'csv';
export const PREFIX = new Date().toJSON().slice(0, 10);
export const SUFFIX = 'export';

class CsvExport
{
    exportToCsv(filename, fileContent) {
        // If fileContent is JSON (object/array), convert to CSV
        if (typeof fileContent === 'object') {
            fileContent = this._jsonToCsv(fileContent);
        }
        const anchor = document.createElement('a');
        anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(fileContent);
        anchor.target = '_blank';
        anchor.download = `${PREFIX}-${filename}_${SUFFIX}.${EXPORT_EXTENSION}`;
        anchor.click();
    }

    _jsonToCsv(data) {
        // Handle hydra collection format
        const items = data['hydra:member'] || (Array.isArray(data) ? data : [data]);
        if (!items.length) return '';

        // Get headers from first item, exclude @id/@type/@context
        const headers = Object.keys(items[0]).filter(k => !k.startsWith('@') && !k.startsWith('hydra:'));
        const separator = ';';

        // Build CSV
        const headerLine = headers.join(separator);
        const lines = items.map(item =>
            headers.map(h => {
                let val = item[h];
                if (val === null || val === undefined) return '';
                if (typeof val === 'object') val = JSON.stringify(val);
                // Escape quotes and wrap in quotes if contains separator
                val = String(val).replace(/"/g, '""');
                if (val.includes(separator) || val.includes('"') || val.includes('\n')) {
                    val = `"${val}"`;
                }
                return val;
            }).join(separator)
        );

        return [headerLine, ...lines].join('\n');
    }
}

export default new CsvExport();